'use client';
import Link from 'next/link';
import { useTranslations } from 'next-intl';
import React, { Dispatch, SetStateAction } from 'react';

import { ButtonStyle } from '@cineamo/ui/src/button/ButtonStyle.enum';
import Button from '@cineamo/ui/src/button/NewButton';
import Modal from '@cineamo/ui/src/modals/Modal';

import { useAnalytics } from '@cineamo/composables/src/providers/analyticsProvider';
import { useCartProvider } from '@cineamo/composables/src/providers/cartProvider';

const CountdownExpiredModal: React.FC<{
    isOpen: boolean;
    setIsOpen: Dispatch<SetStateAction<boolean>>;
}> = ({ isOpen, setIsOpen }) => {
    const t = useTranslations();
    const { track } = useAnalytics();
    const { showing } = useCartProvider();
    return isOpen ? (
        <Modal
            modalIsOpen={isOpen}
            setModalIsOpen={setIsOpen}
            className="max-w-[480px]"
            onClose={() => setIsOpen(false)}
            title={t('tickets.session-timeout')}>
            <div className="flex flex-col space-y-16">
                <p>{t('tickets.session-timeout-message')}</p>
                <Button
                    className="min-h-[48px]"
                    onClick={() => {
                        track('Restarted After Countdown Expired');
                        setIsOpen(false);
                    }}>
                    {t('common.restart')}
                </Button>
                {showing?.contentId && (
                    <Link
                        href={`/program/${showing.contentId}`}
                        onClick={() => {
                            track('Navigated To Movie', {
                                precedingEvent: 'Countdown Expired'
                            });
                            setIsOpen(false);
                        }}>
                        <Button
                            style={ButtonStyle.outlined_on_surface}
                            className="w-full min-h-[48px]">
                            {t('tickets.back-to-movie')}
                        </Button>
                    </Link>
                )}
            </div>
        </Modal>
    ) : null;
};

export default CountdownExpiredModal;
